import { Row } from "@tanstack/react-table";
import { OperationType, SingleItem } from "api-client";
import React from "react";
import { useTranslation } from "react-i18next";
import useMappingEditor from "../useMappingEditor";
import DMEMappingChip from "./DMEMappingChip";

const MappingStatus = ({ row, i }: { row: Row<unknown>; i?: string }) => {
  const { t } = useTranslation();
  const object = row?.original as SingleItem;
  const [loading, setLoading] = React.useState(false);
  const { mappingToObjects } = useMappingEditor();

  const handleUnmatch = React.useCallback(async () => {
    setLoading(true);
    await mappingToObjects(OperationType.UndoMatch, null, object);
    setLoading(false);
  }, [row]);

  if (object?.product_match?.multiple_matches)
    return (
      <span className="text-gray-500">
        {t("mappingEditor.multipleMappings")}
      </span>
    );

  if (object?.product_match?.id) {
    return (
      <DMEMappingChip
        product={object.product_match}
        unmatch={handleUnmatch}
        loading={loading}
      />
    );
  }

  return (
    <div key={i} className="text-xs text-gray-400 w-max">
      {t("mapping.searchAndMap")}
    </div>
  );
};

export default MappingStatus;
